import React from 'react'
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { SalesPeopleView } from './SalesPeople'


const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};



class HhrrAdminView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            tab: 0,

        }
        this.handleClick = this.handleClick.bind(this);
        this.changeTab = this.changeTab.bind(this);
    }


    handleClick(e) {
        this.setState({ open: true });
    }



    changeTab(event, value) {
        this.setState({ tab: value });
    }

 
    render() {
        return (
            <Paper style={paperStyle}>
                <Tabs
                    value={this.state.tab}
                    onChange={this.changeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Vendedores" />
                </Tabs>
                {this.state.tab === 0 && <SalesPeopleView />}
            </Paper>
            

        )
    }
}

export default HhrrAdminView


// WEBPACK FOOTER //
// ./src/components/Admin/Hhrr/HhrrAdminView.js